import React, { FunctionComponent } from 'react'
import useTranslation from '../../hooks/useTranslation'
import LoadingIndicatorWrapper from '../loading-indicator-wrapper'
import ModelsTable from '../models-table'
import ResetCarlineSelection from '../reset-carlines-selection'
import ModelFilters from '../model-filters'
import FilterIcon from '../../assets/media/icons/filter.svg'
import style from './modelSelection.css'
import { ROUTE_MODELS } from '../../constants/routes'

export type Props = {
    modelsLoaded: boolean
    carlineTitle: string
    isLoading: boolean
    cartIsVisible: boolean
    filtersAreVisible: boolean
    modelFiltersEnabled: boolean
    toggleFiltersAreVisible: () => void
}

const ModelSelection: FunctionComponent<Props> = (props) => {
    const {
        carlineTitle,
        isLoading,
        cartIsVisible,
        modelFiltersEnabled,
        filtersAreVisible,
        toggleFiltersAreVisible,
    } = props
    const { t } = useTranslation()

    const toggleButtonLabel = filtersAreVisible
        ? t('modelSelection.hideFilters')
        : t('modelSelection.showFilters')

    return (
        <div className={`${cartIsVisible ? 'contentWithCartboxContainer' : style.container}`}>
            <div className={`${cartIsVisible ? 'contentWithCartbox' : style.content}`}>
                <div data-testid={`page-${ROUTE_MODELS}`}>
                    <h1>{t('modelSelection.heading')}</h1>
                    <LoadingIndicatorWrapper isLoading={isLoading}>
                        <ResetCarlineSelection />
                        <h2 className={style.carlineTitle} data-testid="carline-title-models-page">{carlineTitle}</h2>
                        {modelFiltersEnabled && (
                            <>
                                <div className={style.toggleButtonWrapper}>
                                    <button
                                        className={style.toggleButton}
                                        onClick={toggleFiltersAreVisible}
                                        type="button"
                                        data-testid="model-filter-toggle">
                                        {toggleButtonLabel}
                                        <FilterIcon className={style.icon} />
                                    </button>
                                </div>
                                <div hidden={!filtersAreVisible}>
                                    <ModelFilters isLoading={isLoading} layout="horizontal" />
                                </div>
                            </>
                        )}
                        <ModelsTable isLoading={isLoading} />
                    </LoadingIndicatorWrapper>
                </div>
            </div>
        </div>
    )
}

export default ModelSelection
